import moment from 'moment';
import _ from 'lodash';
let util = {
  url: {},
  ui: {

  }
};
util.ArrSum = function (arr = [], toSumKey) {
  return arr.reduce((p, n) => util.calc.add(p, toSumKey ? (n[toSumKey] || 0) : n), 0);
}

//el-table表格合计计算
util.tableGetSummary = (param, summaryColumnKeys = []) => {
  const { columns, data } = param;
  const sums = [];

  columns.forEach((column, index) => {
    if (index === 1) {
      return sums[index] = '行数:' + data.length
    }

    if (summaryColumnKeys.length && !summaryColumnKeys.includes(column.property)) return;

    const values = data.map(item => Number(item[column.property]));
    if (!values.every(value => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          // return prev + curr;
          return util.calc.add(prev, curr)
        } else {
          return prev;
        }
      }, 0);
      sums[index] = `合计：${(sums[index]).toFixed(2)}`
    } else {
      sums[index] = 'N/A';
    }
  });

  return sums;
}
util.deepCopy = function (obj) {
  return _.cloneDeep(obj)
}
//JavaScript获取当前url根目录(路径)
util.getRealPath = function () {
  var curWwwPath = window.document.location.href;
  var pathName = window.document.location.pathname;
  var pos = curWwwPath.indexOf(pathName);
  var localhostPaht = curWwwPath.substring(0, pos);

  return localhostPaht;
};
//前端权限校验
util.hasPermission = function (permission) {


  return found;
};
//获取前端地址参数对象
util.getRequestSearchObject = function () {
  var url = window.location.search; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      //就是这句的问题
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      //之前用了unescape()
      //才会出现乱码
    }
  }
  return theRequest;
};
//字符串转化为日期类型
util.toLocalDate = function (input) {
  if (!input) {
    return null;
  }
  let a = moment(input);

  let b = a.toDate();
  return b;
};
//根据数据字典Id，获取显示名称
util.dataDicFormat = function (dicType, dicId) {
  if (!dicId || !dicType) {
    return '';
  }
  let dic = tapp.data.base_datadictionary[dicType.toLowerCase()];
  if (!dic || dic.length == 0) {
    return '';
  }
  let isTree = dic[0].hasOwnProperty('items') && Array.isArray(dic[0].items);

  let data = [];
  if (isTree) {
    data = util.treeToArray(dic);
  } else {
    data = [...dic];
  }

  let dicItem = data.find(i => i.id === dicId);
  if (!dicItem) {
    return '';
  }
  if (isTree) {
    return !dicItem.path ? '' : dicItem.path.replace('.;', '').replace(';', '/')
  } else {
    return dicItem.name || '';
  }
};
//根据数据字典Id列表，获取用','分隔的显示名称
util.dataDicsFormat = function (dicType, dicIds) {
  if (!dicIds || !dicType) {
    return '';
  }
  let dic = tapp.data.base_datadictionary[dicType.toLowerCase()];
  if (!dic) {
    return '';
  }
  let isTree = dic[0].hasOwnProperty('items') && Array.isArray(dic[0].items);
  let data = [];
  if (isTree) {
    data = util.treeToArray(dic);
  } else {
    data = [...dic];
  }
  let checkedDicItemIds = Array.isArray(dicIds) ? dicIds : dicIds.split(';');
  let dicItems = data.filter(i => checkedDicItemIds.includes(i.id));
  if (isTree) {
    return dicItems.map(p => p.path.replace('.;', '').replace(';', '/')).join(",");
  } else {
    return dicItems.map(p => p.name).join(",");
  }
};
//根据字典类别生成grid探件的过滤条件
util.getListDataDicFilters = function (dicType) {
  if (!dicType) {
    return [];
  }
  let data = tapp.data.base_datadictionary[dicType.toLowerCase()];
  if (!data) {
    return [];
  }
  return data.map(p => {
    return {
      text: p.name,
      value: p.id
    };
  });
},
  //根据输入datePattern做日期格式化
  util.datePatternFormat = function (input, fmt) {
    if (!input) {
      return '';
    }
    let a = moment(input)
    if (a.isValid()) {
      a = a.utc(8);
      return a.format(fmt);
    }

    return input;
  };
//日期时间格式化,:YYYY-MM-DD HH:mm:ss格式
util.datetimeFormat = function (input) {

  return util.datePatternFormat(input, 'YYYY-MM-DD HH:mm:ss');

};
//日期格式化,:YYYY-MM-DD格式
util.dateFormat = function (input) {
  return util.datePatternFormat(input, 'YYYY-MM-DD');
};

//数字格式化，如：数字输入100000，格式化后：100,000.00
util.numberFormat = function (input, precision) {
  if (input == null) {
    return '';
  }
  let s = accounting.formatNumber(input, {
    precision: precision
  })
  return s;
};
//整形格式化，如：数字输入100000，格式化后：100,000
util.intFormat = function (input) {
  if (input == null) {
    return '';
  }
  let s = accounting.formatNumber(input, {
    precision: 0
  })
  return s;
};
//货币格式化，如：数字输入100000，格式化后：¥100,000.00
util.moneyFormat = function (input) {
  if (input == null) {
    return '';
  }
  let s = accounting.formatMoney(input, {
    symbol: '¥',

  })
  return s;
};
//货币阿拉伯数字转中文大写格式
util.moneyArabiaToChinese = function (Num) {
  let isNegative = false; // 是否负数
  if (Num < 0) {
    Num = -Num;
    isNegative = true;
  }
  if (typeof Num == 'number') {
    Num = Num.toString();
  }
  for (var i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(",", ""); // 替换money中的“,”
    Num = Num.replace(" ", ""); // 替换money中的空格
  }
  Num = Num.replace("￥", ""); // 替换掉可能出现的￥字符
  if (isNaN(Num)) { // 验证输入的字符是否为数字
    return;
  }
  // ---字符处理完毕，开始转换，转换采用前后两部分分别转换---//
  let part = String(Num).split(".");
  let newchar = "";
  // 小数点前进行转化
  for (let i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      alert("位数过大，无法计算");
      return "";
    } // 若数量超过拾亿单位，提示
    let tmpnewchar = "";
    let perchar = part[0].charAt(i);
    switch (perchar) {
      case "0":
        tmpnewchar = "零" + tmpnewchar;
        break;
      case "1":
        tmpnewchar = "壹" + tmpnewchar;
        break;
      case "2":
        tmpnewchar = "贰" + tmpnewchar;
        break;
      case "3":
        tmpnewchar = "叁" + tmpnewchar;
        break;
      case "4":
        tmpnewchar = "肆" + tmpnewchar;
        break;
      case "5":
        tmpnewchar = "伍" + tmpnewchar;
        break;
      case "6":
        tmpnewchar = "陆" + tmpnewchar;
        break;
      case "7":
        tmpnewchar = "柒" + tmpnewchar;
        break;
      case "8":
        tmpnewchar = "捌" + tmpnewchar;
        break;
      case "9":
        tmpnewchar = "玖" + tmpnewchar;
        break;
    }
    switch (part[0].length - i - 1) {
      case 0:
        tmpnewchar = tmpnewchar + "元";
        break;
      case 1:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "拾";
        break;
      case 2:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "佰";
        break;
      case 3:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "仟";
        break;
      case 4:
        tmpnewchar = tmpnewchar + "万";
        break;
      case 5:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "拾";
        break;
      case 6:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "佰";
        break;
      case 7:
        if (perchar != 0)
          tmpnewchar = tmpnewchar + "仟";
        break;
      case 8:
        tmpnewchar = tmpnewchar + "亿";
        break;
      case 9:
        tmpnewchar = tmpnewchar + "拾";
        break;
    }
    newchar = tmpnewchar + newchar;
  }
  // 小数点之后进行转化
  if (Num.indexOf(".") != -1) {
    if (part[1].length > 2) {
      part[1] = part[1].substr(0, 2);
    }
    for (var i = 0; i < part[1].length; i++) {
      let tmpnewchar = "";
      let perchar = part[1].charAt(i);
      switch (perchar) {
        case "0":
          tmpnewchar = "零" + tmpnewchar;
          break;
        case "1":
          tmpnewchar = "壹" + tmpnewchar;
          break;
        case "2":
          tmpnewchar = "贰" + tmpnewchar;
          break;
        case "3":
          tmpnewchar = "叁" + tmpnewchar;
          break;
        case "4":
          tmpnewchar = "肆" + tmpnewchar;
          break;
        case "5":
          tmpnewchar = "伍" + tmpnewchar;
          break;
        case "6":
          tmpnewchar = "陆" + tmpnewchar;
          break;
        case "7":
          tmpnewchar = "柒" + tmpnewchar;
          break;
        case "8":
          tmpnewchar = "捌" + tmpnewchar;
          break;
        case "9":
          tmpnewchar = "玖" + tmpnewchar;
          break;
      }
      if (i == 0)
        tmpnewchar = tmpnewchar + "角";
      if (i == 1)
        tmpnewchar = tmpnewchar + "分";
      newchar = newchar + tmpnewchar;
    }
  }
  // 替换所有无用汉字
  while (newchar.search("零零") != -1)
    newchar = newchar.replace("零零", "零");
  newchar = newchar.replace("零亿", "亿");
  newchar = newchar.replace("亿万", "亿");
  newchar = newchar.replace("零万", "万");
  newchar = newchar.replace("零元", "元");
  newchar = newchar.replace("零角", "");
  newchar = newchar.replace("零分", "");

  if (newchar.charAt(newchar.length - 1) == "元" || newchar.charAt(newchar.length - 1) == "角") {
    newchar = newchar + "整";
  }

  if (isNegative) {
    newchar = '负' + newchar;
  }

  return newchar;
};
//百分比格式化，如0.15,格式化后 15%
util.percentFormat = function (input) {
  if (input == null) {
    return '';
  }

  let s = accounting.formatMoney(input, {
    symbol: '%',
    format: "%v %s"
  })
  return s;
};

//验证输入字符串是否是有效的手机号码
util.verifyMobile = function (str) {
  let re = /^1\d{10}$/;
  return re.test(str);
};
//验证输入字符串字符是否都是数字
util.verifyNumber = function (str) {
  let re = /^\d+$/;
  return re.test(str);
};
//验证输入日期是否小于等于当前日期
util.verifyLTDateNow = function (input) {
  let a = moment(input);
  let b = a.toDate();
  let r = b <= Date.now();
  return r;
};
//验证输入日期是否大于等于当前日期
util.verifyGTDateNow = function (input) {
  let now = new Date();
  let a = moment(input);
  let b = a.toDate();
  let r = b >= new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return r;
};
//验证输入字符串字符是否有效的身份证号码
util.verifyIdCard = function (input) {
  if (input == null) {
    return true;
  }
  return idcard.verify(input);
};
//解析身份证号码字符串的信息
util.parseIdCard = function (input) {
  if (input == null) {
    return '';
  }

  let cardNoInfo = idcard.info(input);
  if (cardNoInfo && cardNoInfo.valid) {
    let birthdayStr = cardNoInfo.birthday.toString();
    cardNoInfo.birthdayString = birthdayStr.substr(0, 4) + "-" +
      birthdayStr.substr(4, 2) +
      "-" +
      birthdayStr.substr(6, 2) +
      " 00:00:00";
  }
  return cardNoInfo;
};




//读取树形实体的所有叶子结点
util.getTreeLeafNodes = function (nodes) {
  let leaftNodes = [];
  util.retriveTree(nodes, (node) => {
    if (!node.items || node.items.length == 0) {
      leaftNodes.push(node);
    }
  })
  return leaftNodes;
};
//树形实体转换为数组结构
util.treeToArray = function (nodes) {
  let allnodes = [];

  util.retriveTree(nodes, (node) => {
    let {
      self
    } = node;
    Object.assign(node, self);
    if (node._expanded === undefined) {
      node._expanded = true;
    }
    allnodes.push(node);
  })
  return allnodes;
};
//数组结构转换为树形实体
util.arrayToTree = function (arr) {
  let tree = [],
    mappedArr = {},
    arrElem, mappedElem;
  // First map the nodes of the array to an object -> create a hash table.

  for (var i = 0, len = arr.length; i < len; i++) {
    arrElem = arr[i];
    mappedArr[arrElem.id] = arrElem;
    mappedArr[arrElem.id]['items'] = [];
  }
  for (var id in mappedArr) {
    if (mappedArr.hasOwnProperty(id)) {
      mappedElem = mappedArr[id];       // If the element is not at the root level, add it to its parent array of children.

      if (mappedElem.parentId) {
        mappedArr[mappedElem['parentId']]['items'].push(mappedElem);
      }       // If the element is at the root level, add it to first level elements array.    
      else {
        tree.push(mappedElem);
      }
    }
  }
  return tree;
};


util.download = function (fileName, url, params) {
  window.vue.$http.request({
    url: url,
    method: 'post',
    data: params,
    responseType: 'blob'
  }).then(res => {
    const content = res
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  }).catch(err => {
    alert(err);
  })
};

//  富文本转义
util.htmlDecodeByRegExp = (str) => {
  var temp = "";
  if (str.length == 0) return "";
  temp = str.replace(/&amp;/g, "&");
  temp = temp.replace(/&lt;/g, "<");
  temp = temp.replace(/&gt;/g, ">");
  temp = temp.replace(/&nbsp;/g, " ");
  temp = temp.replace(/&#39;/g, "'");
  temp = temp.replace(/&quot;/g, '"');
  temp = temp.replace(/↵/g, "");
  return temp;
}
util.calc = {
  /**
   * 加法
   * @param num1
   * @param num2
   * @returns {number}
   */
  add(num1, num2) {
    let baseNum;
    let baseNum1;
    let baseNum2;

    try {
      baseNum1 = num1.toString().split('.')[1].length;
    } catch (e) {
      baseNum1 = 0;
    }

    try {
      baseNum2 = num2.toString().split('.')[1].length;
    } catch (e) {
      baseNum2 = 0;
    }

    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));

    return (num1 * baseNum + num2 * baseNum) / baseNum;
  },

  /**
   * 减法
   * @param num1
   * @param num2
   * @returns {string}
   */
  sub(num1, num2) {
    let baseNum;
    let baseNum1;
    let baseNum2;
    let precision; // 精度

    try {
      baseNum1 = num1.toString().split('.')[1].length;
    } catch (e) {
      baseNum1 = 0;
    }

    try {
      baseNum2 = num2.toString().split('.')[1].length;
    } catch (e) {
      baseNum2 = 0;
    }

    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;

    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
  },

  /**
   * 乘法
   * @returns {number}
   */
  times() {
    let m = 0;
    let strArr = 1;

    [...arguments].forEach(val => {
      try {
        val = !val ? 0 : val;
        if (val.toString().indexOf('.') > 0) {
          m += val.toString().split('.')[1].length;
          val = Number(val.toString().replace('.', ''));
        }

        strArr *= Number(val);
      } catch (e) {
      }
    });
    return strArr / Math.pow(10, m);
  },

  /**
   * 除法
   * @param num1
   * @param num2
   * @returns {number}
   */
  divide(num1, num2) {
    let baseNum1 = 0;
    let baseNum2 = 0;
    let baseNum3, baseNum4;
    try {
      baseNum1 = num1.toString().split('.')[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum3 = Number(num1.toString().replace('.', ''));
    baseNum4 = Number(num2.toString().replace('.', ''));
    return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
  },


};
export default util;



// WEBPACK FOOTER //
// ./src/util/index.js